module.exports = __webpack_public_path__ + "static/media/headder.ec8e1432.jpg";